import type { AcceptAIFieldResponse } from 'api';

export const acceptAIFieldsError = (
  { accepted_fields, errors }: AcceptAIFieldResponse,
  requestedFields: string[]
): string | undefined =>
  errors.length || requestedFields.some(field => !accepted_fields.includes(field))
    ? errors.join(' ') || 'Failed to accept the suggestion'
    : undefined;
